import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ClickTrackingResponse, Click, ClickModelView } from '../models/clickTracking.model';
import { UtilityService } from './shared/utility.service';
import { SimpleResponse } from '../models/genericResponse.model';
import { delayedRetryHttp } from './shared/delayedRetry';
import { ClickTrackRequest } from '../models/clickTrack';

@Injectable({
  providedIn: 'root'
})
export class ClickTrackingService {
  private baseUrl: string;
  private baseUrl2: string;

  private api: string = "api/Click";
  private api2: string = "api/ClickTrack";
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
    this.baseUrl2 = _baseUrl + this.api2;
    }

  async getClickTrackingList(encryptedUser: string, clpCompanyId: number, clpUserId: number): Promise<ClickModelView[] | void> {
    const a = await this.httpClient
      .get<ClickModelView[]>(`${this.baseUrl}/BindClickData/${clpCompanyId}/${clpUserId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpCompanyId - " + clpCompanyId + " , " + "clpUserId - " + clpUserId, encryptedUser, "ClickTrackingService", "getClickTrackingList"); });
    return a;
  }

  async getClickTrackingLoad(encryptedUser: string, clpCompanyId: number, clpUserId: number, clickID: number): Promise<ClickTrackingResponse | void> {
    const a = await this.httpClient
      .get<ClickTrackingResponse>(`${this.baseUrl}/ClickTracking_Load/${clpCompanyId}/${clpUserId}/${clickID}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpCompanyId - " + clpCompanyId + " , " + "clpUserId - " + clpUserId + " , " + "clickID - " + clickID, encryptedUser, "ClickTrackingService", "getClickTrackingLoad"); });
    return a;
  }

  async saveClickTrackingData(encryptedUser: string, click: Click): Promise<ClickTrackingResponse | void> {
    const a = await this.httpClient.post<ClickTrackingResponse>(`${this.baseUrl}/ClickTracking_Save`, click, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, click, "r - " + encryptedUser, encryptedUser, "ClickTrackingService", "saveClickTrackingData") });
    return a;
  }

  async deleteClickTrackingData(encryptedUser: string, clickID: number): Promise<SimpleResponse | void> {
    const a = await this.httpClient.get<SimpleResponse>(`${this.baseUrl}/ClickTracking_Delete?clickId=${clickID}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clickID - " + clickID, encryptedUser, "ClickTrackingService", "deleteClickTrackingData") });
    return a;
  }

  async handleClickTrack(encryptedUser: string, clickTrackReq: ClickTrackRequest): Promise<SimpleResponse | void> {
    const a = await this.httpClient.post<ClickTrackRequest>(`${this.baseUrl2}/HandleClickTrack`, clickTrackReq, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleNAErrors(err, clickTrackReq, "r - " + encryptedUser, "ClickTrackingService", "handleClickTrack") });
    return a;
  }
}

